import { useState } from 'react';
import { FormControl, FormLabel, Box, Stack } from '@chakra-ui/react';
import { Field, useFormikContext } from 'formik';
import { usePartnerForm } from '../../hooks/usePartnerForm';
import DropDown from '@/components/forms/new/formikFormFields/DropDown';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import {
    formLabelStyling,
    stackSpacing,
    stackStyling,
} from 'components/forms/new/formStyles';
import { FORM_FIELD_PATHS } from '../../constants';

const DefaultPartnerPlan = ({ darkMode, errors, defaultPlansData }) => {
    const [isHovered, setIsHovered] = useState(false);
    const { formData, updateFormData } = usePartnerForm();
    const { setFieldValue } = useFormikContext();

    const handleSelectChange = (item) => {
        const selectedId = item?.id;

        // Update both context state AND Formik state
        updateFormData(FORM_FIELD_PATHS.DEFAULT_PARTNER_PLAN_ID, selectedId);
        setFieldValue(FORM_FIELD_PATHS.DEFAULT_PARTNER_PLAN_ID, selectedId);

        // Also update the name field (will be cleaned before API call)
        if (item) {
            updateFormData(FORM_FIELD_PATHS.DEFAULT_PARTNER_PLAN, item.name);
            setFieldValue(FORM_FIELD_PATHS.DEFAULT_PARTNER_PLAN, item.name);
        } else {
            updateFormData(FORM_FIELD_PATHS.DEFAULT_PARTNER_PLAN, null);
            setFieldValue(FORM_FIELD_PATHS.DEFAULT_PARTNER_PLAN, null);
        }
    };

    const hasError = !!errors?.defaultPartnerPlanID;

    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={hasError}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                align="center"
                sx={stackStyling()}>
                <FormLabel sx={formLabelStyling(darkMode, true)}>
                    Default Plan <span style={{ color: '#e53e3e' }}>*</span>
                </FormLabel>
                <Box flex={1} maxWidth="400px">
                    <Field
                        component={DropDown}
                        id={FORM_FIELD_PATHS.DEFAULT_PARTNER_PLAN_ID}
                        name={FORM_FIELD_PATHS.DEFAULT_PARTNER_PLAN_ID}
                        data={defaultPlansData?.defaultPlans || []}
                        isLoading={defaultPlansData?.isDefaultPlansLoading}
                        shownValue="name"
                        currentId={formData?.defaultPartnerPlanID}
                        selectedId="id"
                        placeholder="Select default partner plan"
                        handleSelectChange={handleSelectChange}
                        width="100%"
                        darkMode={darkMode}
                        validate={() => {
                            if (
                                !formData?.[
                                    FORM_FIELD_PATHS.DEFAULT_PARTNER_PLAN_ID
                                ]
                            ) {
                                return 'Default plan is required';
                            }
                        }}
                    />
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="Select the default billing plan for this partner"
                        ariaLabel="default-partner-plan-tip"
                        left="25px"
                        top="5px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default DefaultPartnerPlan;
